export default __webpack_public_path__ + "static/media/return-small.9f0833ad.svg";